import { type PaginationProps, Pagination as PaginationBase } from '@shared/ui-components';

import { useGlobalCmsContentContext } from '../providers/global-cms-context';

export const Pagination = ({ ...rest }: PaginationProps) => {
  const { cmsContent } = useGlobalCmsContentContext();

  return (
    <PaginationBase
      {...rest}
      label={{
        nextPage: cmsContent.nextPage,
        pagination: cmsContent.pagination,
        previousPage: cmsContent.previousPage,
        totalItemsCount: cmsContent.totalItemsCount,
      }}
    />
  );
};
